import { loadingSpinnerActions } from '../../actions/loadingSpinnerActions';
var AromaticNotesReduxProps = {
    mapDispatchToProps: function (dispatch) {
        return {
            onShowSpinner: function () { return dispatch({ type: loadingSpinnerActions.SHOW_SPINNER_MODAL }); },
            onHideSpinner: function () { return dispatch({ type: loadingSpinnerActions.HIDE_SPINNER_MODAL }); },
        };
    },
};
export default AromaticNotesReduxProps;



//////////////////
// WEBPACK FOOTER
// ./src/views/AromaticNote/AromaticNotesReduxProps.ts
// module id = 321
// module chunks = 0